import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {appAnimations} from '../../animations';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {Alert} from '../../models/alert.model';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: appAnimations
})
export class NotificationModalComponent implements OnInit {
  public loading = false;
  public noti: Alert;
  public title: string = '';
  public alerts: Array<Alert> = [];
  public cancelText: string = 'Cerrar';
  public accpetText: string = 'Ir';

  constructor(@Inject(MAT_DIALOG_DATA) private input: {
                noti: Alert,
                cancelText: string,
                acceptText: string
              },
              private route: Router,
              private notificationService: NotificationService,
              private dialogRef: MatDialogRef<NotificationModalComponent>
  ) {
    this.dialogRef.disableClose = true;
    this.noti = this.input.noti;

    this.title += this.noti.title;

    if (this.input.cancelText) {
      this.cancelText = this.input.cancelText;
    }

    if (this.input.acceptText) {
      this.accpetText = this.input.acceptText;
    }
    
  }

  ngOnInit(): void {
  }

  public close(): void {
    this.dialogRef.close({
      result: false,
      data: null,
      error: null
    });
  }

  public accept(): void {
    if (this.noti.type == 7 && (this.noti.advance_id !== null && this.noti.advance_id > 0)) {
      this.notificationService.getInfoForSignedDocument(this.noti.advance_id).subscribe((response) => {
        this.dialogRef.close({
          result: true,
          data: response,
          error: null
        });
      }, err => {
        this.dialogRef.close({
          result: false,
          data: null,
          error: err?.error?.message ?? 'Por favor intenta de nuevo'
        });
      });

      return;
    } if (this.noti.type == 7 && (this.noti.property_id !== null && this.noti.property_id > 0)) {
      this.notificationService.getInfoForLeasingDocument(this.noti.property_id).subscribe(response => {
        this.dialogRef.close({
          result: true,
          data: response,
          error: null
        });
      }, err => {
        this.dialogRef.close({
          result: false,
          data: null,
          error: err?.error?.message ?? 'Por favor intenta de nuevo'
        });
      });

      return;
    } else {
      this.dialogRef.close({
        result: true,
        data: null,
        error: null
      });
    }
  }

}
